export default __webpack_public_path__ + "static/media/gallery-wip-denix-grips_02.29388a17.jpg";